module.exports = __webpack_public_path__ + "media/facebook.3ad226f4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/templates/app-website/assets/facebook.svg
// module id = ./src/templates/app-website/assets/facebook.svg
// module chunks = 0